export default __webpack_public_path__ + "static/do-use-sparingly-9efaaac593ff38b6381524d479ceb350.png";